import React, { useContext, useEffect, createContext, useReducer } from "react";
import { getCountries, getProjects } from "../services";

const ourOffices = ["Jordan", "Palestine", "Belgium", "Tunisia"];

const PROJECT_ACTION_TYPES = {
  SET_SELECTED_COUNTRY: "SET_SELECTED_COUNTRY",
  SET_PROJECTS: "SET_PROJECTS",
  SET_HOVERED_COUNTRY: "SET_HOVERED_COUNTRY",
  SET_FILTERED_PROJECTS: "SET_FILTERED_PROJECTS",
  SET_COUNTRIES: "SET_COUNTRIES",
  SET_HAS_PROJECTS: "SET_HAS_PROJECTS",
};
const INITIAL_STATE = {
  countryList: [],
  ourOffices,
  selectedCountry: "",
  projects: [],
  filteredProjects: [],
  hoveredCountry: "",
  hasProjectsLength: false,
};

const ProjectContext = createContext();

export const projectContext = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case PROJECT_ACTION_TYPES.SET_SELECTED_COUNTRY:
      return { ...state, selectedCountry: payload };
    case PROJECT_ACTION_TYPES.SET_PROJECTS:
      return { ...state, projects: payload, filteredProjects: payload };
    case PROJECT_ACTION_TYPES.SET_HOVERED_COUNTRY:
      return { ...state, hoveredCountry: payload };
    case PROJECT_ACTION_TYPES.SET_FILTERED_PROJECTS:
      return { ...state, filteredProjects: payload };
    case PROJECT_ACTION_TYPES.SET_COUNTRIES:
      return { ...state, countryList: payload };
    case PROJECT_ACTION_TYPES.SET_HAS_PROJECTS:
      return { ...state, hasProjectsLength: payload };
    default:
      throw new Error(`ERROR`);
  }
};

export const ProjectContextProvider = ({ children }) => {
  const [
    {
      countryList,
      ourOffices,
      selectedCountry,
      projects,
      hoveredCountry,
      filteredProjects,
      hasProjectsLength,
    },
    dispatch,
  ] = useReducer(projectContext, INITIAL_STATE);

  const setSelectedCountry = (payload) => {
    filterProjects(payload);
    dispatch({ type: PROJECT_ACTION_TYPES.SET_SELECTED_COUNTRY, payload });
  };

  const setTooltipContent = (payload) => {
    dispatch({ type: PROJECT_ACTION_TYPES.SET_HOVERED_COUNTRY, payload });
  };

  const filterProjects = (country) => {
    let foundProjects = projects.filter((p) => p.country.includes(country));
    if (country === "All Countries") {
      foundProjects = projects;
    }
    if (!foundProjects.length) {
      foundProjects = "";
    }
    dispatch({
      type: PROJECT_ACTION_TYPES.SET_FILTERED_PROJECTS,
      payload: foundProjects,
    });
  };

  const hasProjects = (country) => {
    let foundProjects = projects.filter((p) => p.country.includes(country));
    dispatch({
      type: PROJECT_ACTION_TYPES.SET_HAS_PROJECTS,
      payload: !!foundProjects,
    });
  };

  useEffect(() => {
    const fetchProjects = async () => {
      const projects = await getProjects();
      dispatch({ type: PROJECT_ACTION_TYPES.SET_PROJECTS, payload: projects });
    };
    const fetchCountries = async () => {
      let countries = await getCountries();
      dispatch({
        type: PROJECT_ACTION_TYPES.SET_COUNTRIES,
        payload: countries,
      });
    };
    fetchCountries();
    fetchProjects();
  }, []);

  const value = {
    countryList,
    ourOffices,
    selectedCountry,
    projects,
    hoveredCountry,
    filteredProjects,
    hasProjectsLength,
    setSelectedCountry,
    setTooltipContent,
    hasProjects,
  };

  return (
    <ProjectContext.Provider value={value}>{children}</ProjectContext.Provider>
  );
};

export function useProjectContext() {
  const context = useContext(ProjectContext);
  if (context === undefined) {
    throw new Error("Context must be used within a Provider");
  }
  return context;
}
